import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import CsrfService from '@/common/csrf.service'
import FpApiService from '@/common/api.service'
import STATUS_CODES from "@/common/statusCodes";
import store from '@/store'
import router from '@/router'
import Snotify from 'vue-snotify'
import 'vue-snotify/styles/material.css'
import {format} from "date-fns";

const ApiService = {
  init () {
    Vue.use(VueAxios, axios)
    Vue.use(Snotify, {
      toast: {
        timeout: 2500
      }
    })
    this.setHeader()

    Vue.axios.interceptors.response.use(( data ) => {
      window.localStorage.setItem("expired", "0")
      window.localStorage.setItem("pastDue", "0")
      return data
    }, (error) => {
      if ((error.response.status === 406 && error.response.data.status.code === STATUS_CODES.FP_406) || (error.response.status === 401 && error.response.data.status.code === STATUS_CODES.FP_401))  {
        CsrfService.destroyToken()
        FpApiService.removeTokenAuthHeader()
        window.localStorage.removeItem('user')
        router.push({ name: "Login" })
        if (window.localStorage.getItem("expired") === "0" && (error.response.status === 406 && error.response.data.status.code === STATUS_CODES.FP_406)) {
          Vue.prototype.$snotify.error("Your session has expired.", "ERROR")
          window.localStorage.setItem("expired", "1")
          return
        }
      } else if (error.response.status === 402 && error.response.data.status.code === STATUS_CODES.FP_402) {
        if (window.localStorage.getItem("pastDue") === "0") {
          store.dispatch('SUBSCRIPTION_PAST_DUE_LOCK', true)
          router.push({ name: "PaymentMethods" })
          Vue.prototype.$snotify.error("Your subscription has expired. Please add a valid payment method and retry the payment manually to continue using FamiliPay.", "ERROR")
          window.localStorage.setItem("pastDue", "1")
          return
        }
      }
       else if (error.response.status === 403 && error.response.data.status.code === STATUS_CODES.FP_405) {
        Vue.prototype.$snotify.error("This action is forbidden on the Demo environment.", "ERROR");
        return Promise.reject(error);
      }
      else {
          window.localStorage.setItem("expired", "0")
          window.localStorage.setItem("pastDue", "0")
      }
      return Promise.reject(error)
    })
  },

  setHeader () {
    let fpCsrf = CsrfService.getToken()

    if (fpCsrf) {
      Vue.axios.defaults.headers.common['fp-csrf'] = fpCsrf;
      Vue.axios.defaults.headers.common['zoneId'] = format(new Date(), 'yyyy-MM-dd\'T\'HH:mm:ss.SSSxxx').slice(-6);
    }

    window.localStorage.setItem("expired", "0")
    window.localStorage.setItem("pastDue", "0")
  },

  removeTokenAuthHeader () {
    Vue.axios.defaults.headers.common['fp-csrf'] = ''
  },

  get (url) {
    return axios.get(url, { withCredentials: true })
  },

  post (url, params) {
    return Vue.axios.post(url, params, { withCredentials: true })
  },

  postFormData (url, params) {
    return Vue.axios({
      method: 'post',
      url,
      data: params,
      headers: {
        'Content-Type': undefined
      },
      withCredentials: true
    })
  },

  put (url) {
    return Vue.axios.put(url, { withCredentials: true })
  },

  putData (url, params) {
    return Vue.axios.put(url, params, { withCredentials: true })
  },

  putFormData (url, params) {
    return Vue.axios({
      method: 'put',
      url,
      data: params,
      headers: {
        'Content-Type': undefined
      },
      withCredentials: true
    })
  },

  delete (url) {
    return Vue.axios
      .delete(url, { withCredentials: true })
  }
}

window.onstorage = function(e) {
  if (e.oldValue !== e.newValue) {
    FpApiService.setHeader()
  }
};

export default ApiService
